import { ObservableFromFetch } from "../ObservableFromFetch"
import DeleteModel from "./Model/DeleteModel"

export default function DeleteInvitation(deleteModel: DeleteModel) {
    const requestBody = JSON.stringify(deleteModel)
    return ObservableFromFetch<string>("FFOrderClinicEnrollment/DeleteInvitation", requestBody)
}